export enum permissions {
  ACTIVATE_DATA_LIST = 'ACTIVATE_DATA_LIST',
  ACTIVATE_PROCESS = 'ACTIVATE_PROCESS',
  ACTIVATE_USER = 'ACTIVATE_USER',
  ASSIGN_TASK = 'ASSIGN_TASK',
  ASSIGN_TASK_TO_OTHER = 'ASSIGN_TASK_TO_OTHER',
  CANCEL_REQUEST = 'CANCEL_REQUEST',
  CREATE_DATA_LIST = 'CREATE_DATA_LIST',
  CREATE_ORGANIZATION = 'CREATE_ORGANIZATION',
  CREATE_PROCESS = 'CREATE_PROCESS',
  CREATE_REQUEST = 'CREATE_REQUEST',
  CREATE_SETTINGS_PROCESS = 'CREATE_SETTINGS_PROCESS',
  CREATE_SETTINGS_TASK = 'CREATE_SETTINGS_TASK',
  CREATE_USER = 'CREATE_USER',
  EXECUTE_TASK = 'EXECUTE_TASK',
  INACTIVE_PROCESS = 'INACTIVE_PROCESS',
  REMOVE_ORGANIZATION = 'REMOVE_ORGANIZATION',
  REMOVE_PROCESS = 'REMOVE_PROCESS',
  REMOVE_SETTINGS_PROCESS = 'REMOVE_SETTINGS_PROCESS',
  REMOVE_SETTINGS_TASK = 'REMOVE_SETTINGS_TASK',
  REMOVE_USER = 'REMOVE_USER',
  UNASSIGN_TASK = 'UNASSIGN_TASK',
  UNASSIGN_TASK_TO_OTHER = 'UNASSIGN_TASK_TO_OTHER',
  UPDATE_DATA_LIST = 'UPDATE_DATA_LIST',
  UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION',
  UPDATE_PROFILE = 'UPDATE_PROFILE',
  UPDATE_SETTINGS_PROCESS = 'UPDATE_SETTINGS_PROCESS',
  UPDATE_SETTINGS_TASK = 'UPDATE_SETTINGS_TASK',
  UPDATE_USER = 'UPDATE_USER',
  VIEW_ALL_DATA_LISTS = 'VIEW_ALL_DATA_LISTS',
  VIEW_ALL_PROCESS = 'VIEW_ALL_PROCESS',
  VIEW_ALL_SETTINGS_PROCESS = 'VIEW_ALL_SETTINGS_PROCESS',
  VIEW_ALL_SETTINGS_TASK = 'VIEW_ALL_SETTINGS_TASK',
  VIEW_ALL_TASKS = 'VIEW_ALL_TASKS',
  VIEW_ALL_USER = 'VIEW_ALL_USER',
  VIEW_CLIENT_REQUEST = 'VIEW_CLIENT_REQUEST',
  VIEW_SUPPLIER_REQUEST = 'VIEW_SUPPLIER_REQUEST',
  VIEW_DASHBOARD = 'VIEW_DASHBOARD',
  VIEW_DETAILS_REQUEST = 'VIEW_DETAILS_REQUEST',
  VIEW_DETAILS_TASK = 'VIEW_DETAILS_TASK',
  VIEW_EXECUTIONS = 'VIEW_EXECUTIONS',
  VIEW_HISTORY_REQUEST = 'VIEW_HISTORY_REQUEST',
  VIEW_REPORTS = 'VIEW_REPORTS',
  VIEW_REQUEST = 'VIEW_REQUEST',
}

export enum profiles {
  CLIENT = 'Client',
  SUPPLIER = 'Supplier',
}

export enum urls {
  CHANGE_FORGOT_PASSWORD = '/change-forgot-password',
  DATA = '/data',
  DATA_LISTS = '/data-lists',
  DATA_LISTS_NEW = '/data-lists/new',
  DATA_LISTS_UPDATE = '/data-lists/:id',
  DATA_LISTS_UPDATE_DATA = '/data-lists-update-data/:id',
  EXECUTIONS = '/executions',
  FORBIDDEN = '/forbidden',
  FORGOT_PASSWORD = '/forgot-password',
  PROCESSES = '/processes',
  PROCESSES_NEW = '/processes/new',
  PROFILE = '/profile',
  EDIT_PASSWORD = '/edit-password',
  REPORTS_HISTORY = '/reports-history',
  REQUESTS = '/requests',
  SIGNIN = '/',
  TASKS = '/tasks/:id',
  TASK_EXECUTE = '/task/:id',
  USERS = '/users',
  USERS_NEW = '/users/new',
}
